import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About'
import Services from '../views/Services'
import Blog from "../views/Blog";
import ProjectInfo from "../components/ProjectInfo";
import Marketing from "../views/Marketing";
import Visuals from "../views/Visuals";
import Consulting from "../views/Consulting";

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    props: true,
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    props: true,
    component: About
  },
    {
      path: '/project/:id',
      name: 'ProjectInfo',
      props: true,
      component: ProjectInfo
    },
    {
      path: '/services',
      name: 'Services',
      props: true,
      component: Services
    },
    {
      path: '/blog',
      name: 'Blog',
      props: true,
      component: Blog
    },
    {
      path: '/marketing',
      name: 'Marketing',
      props: true,
      component: Marketing
    },
    {
      path: '/visuals',
      name: 'Visuals',
      props: true,
      component: Visuals
    },
    {
      path: '/consulting',
      name: 'Consulting',
      props: true,
      component: Consulting
    }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
